import { shipmentApiClient } from '../shipmentApiClient'
import { updatePickBookingEndpoint } from './endpoint'
import type { UpdatePickBookingParams } from './type'

export const updatePickBooking = async (params: UpdatePickBookingParams): Promise<void> => {
  await shipmentApiClient.post(updatePickBookingEndpoint(params.shipmentUid), {
    deliveryReportUid: params.deliveryReportUid,
    driverPhone: params.driverPhone,
    pickBookingId: params.pickBookingId,
  })
}
